const SOURCE_NAMES: Record<string, string> = {
  commbuys: 'COMMBUYS',
  commbuys_portal: 'COMMBUYS',
};

const normalizeSourceType = (sourceType?: string | null): string =>
  (sourceType || '').trim().toLowerCase().replace(/[\s-]+/g, '_');

export const getOpportunitySourceName = (sourceType?: string | null): string =>
  SOURCE_NAMES[normalizeSourceType(sourceType)] || 'Source website';

export const getOpportunitySourceAriaLabel = (
  sourceType?: string | null,
  destination: 'opportunity' | 'listing' = 'opportunity',
): string => {
  const sourceName = getOpportunitySourceName(sourceType);
  const destinationLabel = destination === 'listing' ? ' listing' : '';
  return `Open ${sourceName}${destinationLabel} in a new tab`;
};
